import { Button } from "@bowfast/ui/components/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@bowfast/ui/components/dialog";
import { DownloadIcon } from "lucide-react";

interface ImportTemplateDialogProps {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  templateName: string;
  onConfirm: () => void;
  isImporting?: boolean;
}

export function ImportTemplateDialog({
  open,
  onOpenChange,
  templateName,
  onConfirm,
  isImporting,
}: Readonly<ImportTemplateDialogProps>) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>Import "{templateName}"?</DialogTitle>
          <DialogDescription>
            This will create skill categories and skills in your framework. You can rename, reorder, or delete them
            after import. Existing categories are not overwritten.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter showCloseButton>
          <Button className="gap-2" onClick={onConfirm} {...(isImporting ? { disabled: true } : {})}>
            <DownloadIcon className="size-3.5" />
            {isImporting ? "Importing…" : "Import"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
